import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, Selection } from '@nextui-org/react';
import React, { useEffect } from 'react';

export const SelectClusterUI = ({
  clusterOption,
  onSelectedClusterChange,
  value,
  width,
}: {
  clusterOption: Array<string>;
  onSelectedClusterChange: (_: string) => void;
  value?: string;
  width?: string;
}) => {
  const [selectedTypeKeys, setSelectedTypeKeys] = React.useState(new Set([value || 'all']));

  useEffect(() => {
    setSelectedTypeKeys(new Set([value || 'all']));
  }, [value]);

  useEffect(() => {
    onSelectedClusterChange(Array.from(selectedTypeKeys)[0] as string);
  }, []);

  useEffect(() => {
    onSelectedClusterChange(Array.from(selectedTypeKeys)[0] as string);
  }, [selectedTypeKeys]);

  const selection = [<DropdownItem key='all'>All Cluster</DropdownItem>];
  clusterOption.forEach(item => {
    selection.push(<DropdownItem key={item}>{item}</DropdownItem>);
  });

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button variant='bordered' size='sm' className={width ? `w-[${width}]` : ''}>
          {Array.from(selectedTypeKeys)[0] === 'all' ? 'All Cluster' : `cluster: ${Array.from(selectedTypeKeys)[0]}`}
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label='Single selection actions'
        variant='flat'
        disallowEmptySelection
        selectionMode='single'
        selectedKeys={selectedTypeKeys}
        onSelectionChange={setSelectedTypeKeys as (_: Selection) => void}
      >
        {selection}
      </DropdownMenu>
    </Dropdown>
  );
};
